<template>
  <div class="bgareportsearch">
    <b-container>
      <div v-cloak>
        <b-alert
            :show="showAlert"
            variant="danger"
        >
          {{ error }}
        </b-alert>
        <template v-if="authorized && preloaded === false">

          <bga-terms-of-use></bga-terms-of-use>

          <b-form ref="reports" @submit.prevent="updateData">

            <div class="accordion" role="tablist">

              <cm-card card-title="Carriers to include in search"
                       toggle="accordion-carriers">
                <b-form-checkbox
                    v-model="selectAllCarriers" :indeterminate="indeterminateCarriers" @change="select('selectedCarriers', selectAllCarriers, carriers, 'id', 'indeterminateCarriers')"
                >
                  {{ selectAllCarriers ? 'Unselect All' : 'Select All' }}
                </b-form-checkbox>
                <b-form-checkbox
                    v-for="carrier in carriers"
                    :key="carrier.id"
                    v-model="selectedCarriers"
                    :value="carrier.id"
                >
                  <span v-html="carrier.name"></span>
                </b-form-checkbox>

              </cm-card>

              <cm-card v-if="reports.length" card-title="Select Reports" toggle="accordion-reports">

                <b-form-group>
                  <b-form-radio-group
                    v-model="selectedReports"
                    name="reports"
                    class="d-block"
                  >
                    <b-form-radio
                      v-for="report in reports"
                      :key="report.id"
                      :value="report.id"
                      class="d-block"
                    >
                      <span v-html="report.title.rendered"></span>
                    </b-form-radio>
                  </b-form-radio-group>
                </b-form-group>

              </cm-card>


              <b-form-checkbox
                  v-if="selectedReports !== []"
                  name="ReportDateConfirmed"
                  switch
                  v-model="selectedReportDateConfirmed"
              >
                Only show Reports verified in the last 18 months
              </b-form-checkbox>

              <div class="d-flex justify-content-between align-items-center">
                <b-button variant="success" v-on:click="updateData">{{this.buttonText}}</b-button>
                <img style="width:120px" src="https://carriermatrix.com/wp-content/uploads/Engineered-By-Simplicity.jpg"  alt="Engineered By Simplicity Group">
              </div>
              <div class="d-flex align-items-center mt-2" v-if="showButtons">
                <b-button class="mr-2" v-if="items.length" variant="info" v-on:click="generateCurrentUrl">Generate URL For Standalone Search Results</b-button>
                <a v-if="generatedUrl" :href="generatedUrl" target="_blank">Generated Report Link</a>
              </div>
              <div class="d-flex align-items-center mt-2" v-if="showButtons">
                <b-button class="mr-2" v-if="items.length" variant="info" v-on:click="generateCurrentCode">Generate Component Code For Standalone Search Results</b-button>
              </div>
              <div class="d-flex align-items-center mt-2" v-if="generatedComponentCode">
                <b-form-group class="w-100" label="Insert the following Custom HTML code on the page you wish to show the Results Table:">
                  <b-form-textarea
                    :value="generatedComponentCode"
                    readonly
                    rows=7
                  ></b-form-textarea>
                </b-form-group>
              </div>
            </div>
          </b-form>

        </template>
      </div>
    </b-container>
  </div>
</template>

<script>
import {bus} from "@/event-bus";
import HelperFunctions from "@/mixins/helper-functions"
export default {
  name: "BGAReportSearch",
  mixins: [HelperFunctions],
  props: {},
  data() {
    return {
      items: [],
      reports: [],
      fields: [],
      reportFields: [],
      selectAllReports: false,
      selectedReports: [],
      selectedReportsCompat: [],
      selectedReportDateConfirmed: true,
      indeterminateReports: false,
      error: '',
      query_args: '',
      showAlert: false,
      generatedUrl: '',
      generatedComponentCode: '',
      preloaded: true,
    }
  },
  mounted() {

    this.fetchCarriers().catch(error => {
      console.error(error)
    })

    this.fetchReports().catch(error => {
      console.error(error)
    })
    this.preloadSearchFilters();
  },
  methods: {

    updateResults() {
      bus.$emit("update-report-results-items", this.items)
      bus.$emit("update-report-visible-fields", this.fields)
      bus.$emit("update-report-preloaded", this.preloaded)
    },

    async fetchReports() {
      const ms = Date.now()
      const params = '?per_page=99&orderby=title&order=asc&agency_id=' + this.agencyId + '&api_key=' + this.apiKey + '&cache_buster=' + ms + '&site=' + window.location.href
      this.reports = await fetch(this.$hostname + '/cm_api/wp/v2/report_form' + params)
          .then(res => {
            return res.json()
          })
          .then(reports => reports)
      this.isBusy = !this.isBusy
    },

    async updateData() {
      this.items = []
      this.updateResults()
      if (!this.selectedCarriers.length) {
        this.showAlert = true
        this.error = 'At least one Carrier needs to be selected'
        this.scrollToTop()
        return
      }

      if (this.selectedReports == [] || typeof this.selectedReports == "undefined" ) {
        this.showAlert = true
        this.error = 'At least one Report needs to be selected'
        this.scrollToTop()
        return
      }

      this.fields = []
      this.items = []
      this.selectedReportsCompat = this.selectedReports
      if (typeof this.selectedReportsCompat != "Array") {
        this.selectedReportsCompat = [this.selectedReportsCompat]
      }
      const formData = new FormData(this.$refs['reports'])
      formData.append('per_page', 99)
      formData.append('selected_carriers', this.selectedCarriers)
      formData.append('selected_reports', this.selectedReportsCompat)
      formData.append('agency_id', this.agencyId)
      formData.append('api_key', this.apiKey)
      formData.append('site', window.location.href)
      const data = {}
      for (let [key, val] of formData.entries()) {
        Object.assign(data, {[key]: val})
      }
      const params = new URLSearchParams(data)
      const options = {
        headers: new Headers(),
      }
      this.items = await fetch(this.$hostname + '/cm_api/cm/v1/report-api?' + params, options)
          .then(res => {
            return res.json()
          })
          .then(items => items)

      for (const i of Object.keys(this.items)) {
        this.fields.push([{
          key: 'carrier', 
          label: 'Carrier', 
          sortable: true, 
          sortByFormatted: true,
          tdClass: 'width-126',
          thClass: 'width-126',
          formatter: value => {
            return (value ? this.getCarrierNameByID(value) : '')
          }
        }])
        
        for (const [j, value] of Object.entries(this.items[i].report_form.field_names)) {
          this.fields[i].push({
            key: 'report_field_'+j, 
            label: value,
            tdClass: `width-${this.items[i].report_form.field_widths[j]}`,
            thClass: `width-${this.items[i].report_form.field_widths[j]}`
          })
        }
      }

      if (this.items.error) {
        this.showAlert = true;
        this.error = this.items.error.message;
        this.query_args = this.items.error.query_args;
        this.scrollToTop();
      }

      // Check if there are no reports in the response
      if (this.items && (!Array.isArray(this.items) || this.items.length === 0 || 
          !this.items.some(item => item.reports && item.reports.length > 0))) {
        this.showAlert = true;
        this.error = 'No Reports Found';
        this.scrollToTop();
      }

      this.updateResults()

    },

    generateCurrentUrl() {
      const params = new URLSearchParams({
        selected_carriers: this.selectedCarriers.join(','),
        selected_reports: this.selectedReportsCompat.join(','),
      });
      this.generatedUrl = window.location.href.split('?')[0] + '?' + params.toString();
    },

    preloadSearchFilters() {
      let urlParams = new URLSearchParams(window.location.search);
      let updated = false;
      this.showButtons = urlParams.get('showButtons') ? urlParams.get('showButtons') : urlParams.get('showbuttons') ? urlParams.get('showbuttons') : false;
      this.selectedCarriers = urlParams.get('selected_carriers') ? urlParams.get('selected_carriers').split(',') : [];
      this.selectedReportsCompat = urlParams.get('selected_reports') ? urlParams.get('selected_reports').split(',') : [];
      this.selectedReports = this.selectedReportsCompat[0];
      if (this.selectedCarriers.length && this.selectedReports) {
        updated = true;
        this.updateData();
      }
      if (this.searchParams) {
        urlParams = new URLSearchParams(this.searchParams);
        this.selectedCarriers = urlParams.get('selected_carriers') ? urlParams.get('selected_carriers').split(',') : [];
        this.selectedReportsCompat = urlParams.get('selected_reports') ? urlParams.get('selected_reports').split(',') : [];
        this.selectedReports = this.selectedReportsCompat[0];
        if (this.selectedCarriers.length && this.selectedReports) {
          updated = true;
          this.updateData();
        }
      }
      if (updated === false) {
        this.preloaded = false
      }
    },

    generateCurrentCode() {
      const params = new URLSearchParams({
        selected_carriers: this.selectedCarriers.join(','),
        selected_reports: this.selectedReportsCompat.join(','),
      }).toString();
      this.generatedComponentCode = `<carrier-matrix form="report" search-params="${params}" button-text="Search" agency-id="${this.agencyId}" api-key="${this.apiKey}"></carrier-matrix>
<carrier-matrix results="report"  results-height="96vh"></carrier-matrix>`;
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.d-flex.align-items-center.mt-2 {
  margin-top: 0.2rem !important; /* Adjust the margin as needed */
}
</style>
